export const InterviewLabel = "Interview";
export const AddInterviewLabel = "Add Interview";
export const EditInterviewLabel = "Edit Interview";
export const CompanyLabel = "Company";
export const AliasedLabel = "Aliased";
export const StaffNameLabel = "Staff Name";
export const TechnologyLabel = "Technology";
export const RoundLabel = "Round";
export const ExperienceLabel = "Experience";
export const DateLabel = "Date";
export const StatusLabel = "Status";
export const ChangeStatus = "Change Status";
export const ScheduledBy = "Scheduled By";
export const InterviewStatus = "Interview Status";
export const InterviewDate = "Interview Date";
export const Center = "Center";
export const StatusFulfilled = "fulfilled";

export const ACCESSOR_KEYS = {
  SRNOLABEL: "Sr no.",
  ROUND: "round",
  ACTION: "action",
  EXPERIENCE: "experience",
  DATE: "date",
  STATUS: "status",
};

export const INTERVIEW_STATUS_OPTIONS = [
  { value: "Selected", label: "Selected" },
  { value: "Rejected", label: "Rejected" },
  { value: "On Hold", label: "On Hold" },
];

export const INTERVIEW_STATUS_BADGE_MAP = {
  Selected: "success",
  Rejected: "danger",
  "On Hold": "warning",
};
